import React, {useState} from "react";
import {Button, Col, Input, Modal, Row, Select, Switch} from "antd";
import axios from "axios";
import {baseURL} from "../service/ApiService";
import TextArea from "antd/es/input/TextArea";
import {EditFilled} from "@ant-design/icons";
import CountryLocation from "../badge/countryLocation";
import {translatePrompt} from "../service/api/userAPI";
import PromptEditTextArea from "../component/promptEditTextArea";

const GptPromptEditModal = ({buttonName, title, prompt, models, callback}) => {
    const [open, setOpen] = useState(false);
    const [currentName, setCurrentName] = useState(prompt.description);
    const [currentCost, setCurrentCost] = useState(prompt.cost);
    const [currentModelId, setCurrentModelId] = useState(prompt.model.id);
    const [currentLanguage, setCurrentLanguage] = useState("EN");
    const [currentChinesePrompt, setCurrentChinesePrompt] = useState(prompt.promptChinese);
    const [currentEnglishPrompt, setCurrentEnglishPrompt] = useState(prompt.promptEnglish);
    const [currentJapanesePrompt, setCurrentJapanesePrompt] = useState(prompt.promptJapanese);
    const [currentCantonesePrompt, setCurrentCantonesePrompt] = useState(prompt.promptCantonese);
    const [currentChineseTaiwanPrompt, setCurrentChineseTaiwanPrompt] = useState(prompt.promptChineseTaiwan);
    const [currentFrenchPrompt, setCurrentFrenchPrompt] = useState(prompt.promptFrench);
    const [currentHindiPrompt, setCurrentHindiPrompt] = useState(prompt.promptHindi);
    const [currentSpanishPrompt, setCurrentSpanishPrompt] = useState(prompt.promptSpanish);
    const [currentPortuguesePrompt, setCurrentPortuguesePrompt] = useState(prompt.promptPortuguese);
    const [currentArabicPrompt, setCurrentArabicPrompt] = useState(prompt.promptArabic);
    const [currentRussianPrompt, setCurrentRussianPrompt] = useState(prompt.promptRussian);
    const [currentKoreanPrompt, setCurrentKoreanPrompt] = useState(prompt.promptKorean);
    const [enableJson, setEnableJson] = useState(prompt.jsonMode);
    const [currentSchema, setCurrentSchema] = useState(prompt.config);

    const showModal = () => {
        setOpen(true)
    }
    const save = (id) => {
        const data = {
            id: id,
            name: currentName,
            cost: currentCost,
            chinesePrompt:        currentChinesePrompt,
            cantonesePrompt:      currentCantonesePrompt,
            chineseTaiwanPrompt:  currentChineseTaiwanPrompt,
            englishPrompt:        currentEnglishPrompt,
            japanesePrompt:       currentJapanesePrompt,
            koreanPrompt:         currentKoreanPrompt,
            frenchPrompt:         currentFrenchPrompt,
            hindiPrompt:          currentHindiPrompt,
            spanishPrompt:        currentSpanishPrompt,
            portuguesePrompt:     currentPortuguesePrompt,
            arabicPrompt:         currentArabicPrompt,
            russianPrompt:        currentRussianPrompt,
            enableJson: enableJson,
            jsonSchema: currentSchema.replace('\u2028', '').replace('\u2029', ''),
            gptModelId: currentModelId
        }
        axios.put(`${baseURL}/api/prompt`, data).then(
            () => {
                callback();
                setOpen(false);
            }
        )
    }

    const translate = (id, language) => {
        translatePrompt(id, language).then(
            res => {
                if(language === "CN") setCurrentChinesePrompt(res.data)
                if(language === "JA") setCurrentJapanesePrompt(res.data)
                if(language === "KO") setCurrentKoreanPrompt(res.data)
                if(language === "ES") setCurrentSpanishPrompt(res.data)
                if(language === "PT") setCurrentPortuguesePrompt(res.data)
                if(language === "ZH_TW") setCurrentChineseTaiwanPrompt(res.data)
                if(language === "ZH_HK") setCurrentCantonesePrompt(res.data)
                if(language === "HI") setCurrentHindiPrompt(res.data)
                if(language === "AR") setCurrentArabicPrompt(res.data)
                if(language === "FR") setCurrentFrenchPrompt(res.data)
                if(language === "RU") setCurrentRussianPrompt(res.data)
            }
        );
    }

    return (
        <>
            <a onClick={showModal} style={{display: 'flex', alignItems: 'center'}}>
                <EditFilled style={{marginRight: 8}}/> {/* Adjust margin as needed */}
                {buttonName}
            </a>
            <Modal
                title={prompt.description}
                centered
                open={open}
                onOk={() => save(prompt.id)}
                onCancel={() => setOpen(false)}
                okText="Save"
                width={1000}
                aria-hidden={!open}
            >
                <Row gutter={16}>
                    <Col span={12}>
                        <h4>Name</h4>
                        <Input value={currentName} onChange={(e) => setCurrentName(e.target.value)}/>
                        <h4>GPT Model</h4>
                        <Select value={currentModelId} onSelect={(e) => setCurrentModelId(e)} style={{ width: '100%' }}>
                            {models.map((model) => (<Select.Option value={model.id}>{model.modelName}</Select.Option>))}
                        </Select>
                        <h4>Cost</h4>
                        <Input value={currentCost} onChange={(e) => setCurrentCost(e.target.value)} />
                        <h4>Language</h4>
                        <Select
                            value={currentLanguage}
                            onSelect={(e) => setCurrentLanguage(e)}
                            style={{ width: '100%' }}
                        >
                            <Select.Option value="EN" >
                                <span style={{ display: 'inline-flex', alignItems: 'center' }}><CountryLocation countryCode="GB" style={{ marginRight: 8 }} /> English</span>
                            </Select.Option>

                            <Select.Option value="CN" >
                                <span style={{ display: 'inline-flex', alignItems: 'center' }}><CountryLocation countryCode="CN" style={{ marginRight: 8 }} /> Chinese</span>
                            </Select.Option>

                            <Select.Option value="JA" >
                                <span style={{ display: 'inline-flex', alignItems: 'center' }}><CountryLocation countryCode="JP" style={{ marginRight: 8 }} /> Japanese</span>
                            </Select.Option>

                            <Select.Option value="ZH_HK">
                                <span style={{ display: 'inline-flex', alignItems: 'center' }}><CountryLocation countryCode="HK" style={{ marginRight: 8 }} /> Cantonese</span>
                            </Select.Option>

                            <Select.Option value="ZH_TW">
                                <span style={{ display: 'inline-flex', alignItems: 'center' }}><CountryLocation countryCode="TW" style={{ marginRight: 8 }} /> Traditional Chinese (Taiwan)</span>
                            </Select.Option>

                            <Select.Option value="FR">
                                <span style={{ display: 'inline-flex', alignItems: 'center' }}><CountryLocation countryCode="FR" style={{ marginRight: 8 }} /> French</span>
                            </Select.Option>

                            <Select.Option value="HI">
                                <span style={{ display: 'inline-flex', alignItems: 'center' }}><CountryLocation countryCode="IN" style={{ marginRight: 8 }} /> Hindi</span>
                            </Select.Option>

                            <Select.Option value="ES">
                                <span style={{ display: 'inline-flex', alignItems: 'center' }}><CountryLocation countryCode="ES" style={{ marginRight: 8 }} /> Spanish</span>
                            </Select.Option>

                            <Select.Option value="PT">
                                <span style={{ display: 'inline-flex', alignItems: 'center' }}><CountryLocation countryCode="PT" style={{ marginRight: 8 }} /> Portuguese</span>
                            </Select.Option>

                            <Select.Option value="AR">
                                <span style={{ display: 'inline-flex', alignItems: 'center' }}><CountryLocation countryCode="SA" style={{ marginRight: 8 }} /> Arabic</span>
                            </Select.Option>

                            <Select.Option value="RU">
                                <span style={{ display: 'inline-flex', alignItems: 'center' }}><CountryLocation countryCode="RU" style={{ marginRight: 8 }} /> Russian</span>
                            </Select.Option>

                            <Select.Option value="KO">
                                <span style={{ display: 'inline-flex', alignItems: 'center' }}><CountryLocation countryCode="KR" style={{ marginRight: 8 }} /> Korean</span>
                            </Select.Option>
                        </Select>

                        <PromptEditTextArea
                            prompt={prompt}
                            currentLanguage={currentLanguage}
                            translate={translate}

                            currentChinesePrompt={currentChinesePrompt}
                            setCurrentChinesePrompt={setCurrentChinesePrompt}
                            currentEnglishPrompt={currentEnglishPrompt}
                            setCurrentEnglishPrompt={setCurrentEnglishPrompt}
                            currentJapanesePrompt={currentJapanesePrompt}
                            setCurrentJapanesePrompt={setCurrentJapanesePrompt}
                            currentCantonesePrompt={currentCantonesePrompt}
                            setCurrentCantonesePrompt={setCurrentCantonesePrompt}
                            currentChineseTaiwanPrompt={currentChineseTaiwanPrompt}
                            setCurrentChineseTaiwanPrompt={setCurrentChineseTaiwanPrompt}
                            currentFrenchPrompt={currentFrenchPrompt}
                            setCurrentFrenchPrompt={setCurrentFrenchPrompt}
                            currentHindiPrompt={currentHindiPrompt}
                            setCurrentHindiPrompt={setCurrentHindiPrompt}
                            currentSpanishPrompt={currentSpanishPrompt}
                            setCurrentSpanishPrompt={setCurrentSpanishPrompt}
                            currentPortuguesePrompt={currentPortuguesePrompt}
                            setCurrentPortuguesePrompt={setCurrentPortuguesePrompt}
                            currentArabicPrompt={currentArabicPrompt}
                            setCurrentArabicPrompt={setCurrentArabicPrompt}
                            currentRussianPrompt={currentRussianPrompt}
                            setCurrentRussianPrompt={setCurrentRussianPrompt}
                            currentKoreanPrompt={currentKoreanPrompt}
                            setCurrentKoreanPrompt={setCurrentKoreanPrompt}
                        />
                    </Col>
                    <Col span={12}>
                        <div style={{display: 'flex', alignItems: 'center', marginBottom: '10px'}}>
                            <h4 style={{margin: 0, marginRight: '10px'}}>JSON Schema</h4>
                            <Switch
                                checked={enableJson}
                                onChange={setEnableJson}
                            />
                        </div>
                        {
                            enableJson ? <TextArea autoSize={true} value={currentSchema}
                                                   onChange={(e) => setCurrentSchema(e.target.value)}/> : ''
                        }
                    </Col>
                </Row>
            </Modal>
        </>
    )
}
export default GptPromptEditModal